
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { InventoryKind } from "../../Shared/InventoryStates.js";
import { ScanResultType__ToI18nString } from "../../Shared/Scan.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Table } from "../Table/Table.js";
import { singleton, toArray, ofArray, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";

function InventoryTable(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const columnDefinition = [new ColumnDefinition$1("image", "", t("general.image"), (row) => {
        const matchValue = row.ImageUrl;
        return (matchValue == null) ? (new CellContent(0, [""])) : (new CellContent(6, [matchValue]));
    }, "none", "text"), new ColumnDefinition$1("inventoryType", "", t("general.tool_type"), (row_1) => {
        const matchValue_1 = row_1.Type;
        return (matchValue_1 === "toolWithQuantity") ? (new CellContent(5, [new InventoryKind(2, [])])) : ((matchValue_1 === "consumable") ? (new CellContent(5, [new InventoryKind(3, [])])) : ((matchValue_1 === "set") ? (new CellContent(5, [new InventoryKind(1, [])])) : ((matchValue_1 === "receiver") ? (new CellContent(0, [t(ScanResultType__ToI18nString(row_1.Type))])) : (new CellContent(5, [new InventoryKind(0, [])])))));
    }, "none", "text"), new ColumnDefinition$1("name", "", t("general.name"), (row_2) => (new CellContent(0, [defaultArg(row_2.Name, "")])), "none", "text"), new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_3) => (new CellContent(0, [defaultArg(row_3.AdditionalName, "")])), "none", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_4) => (new CellContent(0, [defaultArg(row_4.Manufacturer, "")])), "none", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_5) => (new CellContent(0, [defaultArg(row_5.Model, "")])), "none", "text"), new ColumnDefinition$1("inventoryNumber", "", t("tool.inventory_number"), (row_6) => (new CellContent(0, [defaultArg(row_6.InventoryNumber, "")])), "none", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_7) => (new CellContent(0, [defaultArg(row_7.SerialNumber, "")])), "none", "text"), new ColumnDefinition$1("unit", "", t("general.unit"), (row_8) => (new CellContent(0, [defaultArg(map((_arg) => _arg, row_8.Unit), "")])), "none", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (row_9) => (new CellContent(0, [defaultArg(row_9.StorageName, "")])), "none", "text"), new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (row_10) => (new CellContent(0, [defaultArg(row_10.StorageSpace, "")])), "none", "text"), new ColumnDefinition$1("location", "", t("general.location"), (row_11) => (new CellContent(0, [defaultArg(row_11.LocationName, "")])), "none", "text")];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["min-h-48"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems = [createElement(Table, {
        ColumnDefinitions: columnDefinition,
        Controls: empty(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: new OnTableRowClick$1(0, [(row_12) => {
                props.OnClose();
                const matchValue_2 = row_12.Type;
                switch (matchValue_2) {
                    case "toolWithQuantity": {
                        RouterModule_nav(ofArray(["toolswithquantity", row_12.Id]), 1, 1);
                        break;
                    }
                    case "consumable": {
                        RouterModule_nav(ofArray(["consumables", row_12.Id]), 1, 1);
                        break;
                    }
                    case "set": {
                        RouterModule_nav(ofArray(["sets", row_12.Id]), 1, 1);
                        break;
                    }
                    case "receiver": {
                        RouterModule_nav(ofArray(["receivers", row_12.Id]), 1, 1);
                        break;
                    }
                    default:
                        RouterModule_nav(ofArray(["tools", row_12.Id]), 1, 1);
                }
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: toArray(props.ScanResults),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function InventoryListModalSheet(props) {
    let elems;
    return reactElement("div", createObj(singleton((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: createElement(InventoryTable, {
            OnClose: props.OnClose,
            ScanResults: props.ScanResults,
        }),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

